import moment from "moment";

const LOCAL_STORAGE_KEY = "OT-COMPARISONS";


const state = {
    comparisons: []
}


const mutations = {


    loadFromLocalStorage: (state) => {

        const savedComparisons = window.localStorage.getItem(LOCAL_STORAGE_KEY);

        if (!savedComparisons) {
            localStorage.setItem('OT-COMPARISONS', JSON.stringify([]));
            state.comparisons = [];
        } else {
            state.comparisons = JSON.parse(savedComparisons)
            // state.comparisons = [{
            //     id: '1111', name: 'PICO', definitions: [{
            //         operationDefinitionId: null,
            //         searchQueriesWithOperators: [],
            //         operationsList: []
            //     },
            //         {
            //             operationDefinitionId: null,
            //             searchQueriesWithOperators: [],
            //             operationsList: []
            //         }]
            // }]
        }
    },
};

const actions = {
    saveToLocalStorage: (state, comparisonToSave) => {
        try {
            const savedComparisons = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_KEY));

            if (!comparisonToSave.id) {
                comparisonToSave.id = moment().format();

                savedComparisons.push(comparisonToSave);

            } else {
                const savedComparisonIndex = savedComparisons.findIndex(comparison => comparison.id === comparisonToSave.id)
                savedComparisons.splice(savedComparisonIndex, 1, comparisonToSave);
            }

            localStorage.setItem('OT-COMPARISONS', JSON.stringify(savedComparisons));

            return comparisonToSave.id;

        } catch (e) {
            console.warn(e)
        }

    },
}

const getters = {
    getComparisonById: (state) => (id) => state.comparisons.find(comparison => comparison.id === id)
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

